/* globals window */

import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import createStore from './src/state/createStore';
import { hydrate } from "emotion"
import ReactGA from 'react-ga';

exports.replaceRouterComponent = ({ history }) => {
  const store = createStore();

  const ConnectedRouterWrapper = ({ children }) => (
    <Provider store={store}>
      <Router history={history}>{children}</Router>
    </Provider>
  );

  return ConnectedRouterWrapper;
};

exports.onClientEntry = () => {

  // initialize Google Analytics
  ReactGA.initialize('UA-118636651-1');

  initializeReferralMagic();

  if (
    /* eslint-disable no-underscore-dangle */
    typeof window !== `undefined` &&
    typeof window.__EMOTION_CRITICAL_CSS_IDS__ !== `undefined`
  ) {
    hydrate(window.__EMOTION_CRITICAL_CSS_IDS__);
  }
};

function initializeReferralMagic(){
  !function(n){if(!("rfmgc"in window)){window.rfmgc=function(){var n=[].slice.call(arguments),i=[];if(n.length>0){i.push(n.shift());for(var o=0;o<n.length;o++)i.push(n[o])}window.rfmgc.queue.push(i)},window.rfmgc.queue=[],window.rfmgc.token="263deb4349a2e035077df3c86b8f14bb",window.rfmgc.api="//api.referralmagic.co",window.rfmgcConfig&&window.rfmgcConfig.cookieDomain.length>0?window.rfmgc.cookieDomain=window.rfmgcConfig.cookieDomain:window.rfmgc.cookieDomain=null;var i=document.createElement("script");i.src="//cdn.referralmagic.co/js/tracker.js?1",i.async=!0;var o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(i,o)}window.rfmgc}();
}


// WEBPACK FOOTER //
// ./gatsby-browser.js